<template>
    <div>
        <h3
            class="welcome-alert__title mb-4"
            :class="IS_VTR_THEME ? 'text-start' : 'text-center'"
            v-html="welcomeTitle"
        ></h3>

        <Alert
            v-if="!IS_VTR_THEME"
            :text="$t('global.welcome.message')"
            icon="exclamation"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Alert from '@/components/Common/Alert.vue';
import { IS_VTR_THEME } from '@/themes/theme';

const { t } = useI18n();
const welcomeTitle = computed(() => {
    if (IS_VTR_THEME) {
        return 'VTR B2B';
    }

    return t('global.welcome.title');
});
</script>
